var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "RefForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c(
            "BjDivider",
            [
              _vm._v("手动刷新服务权限 "),
              _c(
                "template",
                { slot: "button" },
                [
                  _c("el-button", { on: { click: _vm.onUpdateIAM } }, [
                    _vm._v("刷新"),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "服务名", prop: "instanceId" } },
                    [
                      _c("BjSelectInstancesService", {
                        attrs: { code: "HADM.INSTANCE" },
                        on: { change: _vm.onChangeServiceName },
                        model: {
                          value: _vm.form.instanceId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "instanceId", $$v)
                          },
                          expression: "form.instanceId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v("服务标记版本 "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                placement: "top-start",
                                content: "不输入版本是刷新最新版本",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-question" })]
                          ),
                        ],
                        1
                      ),
                      _c("BjInput", {
                        model: {
                          value: _vm.form.metaVersion,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "metaVersion", $$v)
                          },
                          expression: "form.metaVersion",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "清除过期权限" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.cleanPermission,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cleanPermission", $$v)
                          },
                          expression: "form.cleanPermission",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }